import React from 'react';
import { StyledSystemProps, Typography, Avatar } from '@creditas-ui/react';
import { Profile, Content, Info, Label, ChevronIcon } from './MenuProfile.style';

interface MenuProfileBaseProps {
  children?: React.ReactNode;
  label: string;
}

type MenuProfileElProps = React.HTMLAttributes<HTMLDivElement>;

export type MenuProfileProps = MenuProfileBaseProps & MenuProfileElProps & StyledSystemProps;

const MenuProfile = ({ label, children, ...props }: MenuProfileProps): JSX.Element => {
  const [showOptions, setShowOptions] = React.useState<boolean>(false);

  const handleOnMouseEnter = (): void => setShowOptions(true);

  const handleOnMouseLeave = (): void => setShowOptions(false);

  return (
    <Profile {...props}>
      {label ? (
        <>
          <Content onMouseEnter={handleOnMouseEnter} onMouseLeave={handleOnMouseLeave}>
            <Info>
              <Label>
                <Typography color="neutral.90" variant="bodySmRegular" data-testid="profile-name">
                  {label}
                </Typography>

                <ChevronIcon active={showOptions} />
              </Label>

              {showOptions && children}
            </Info>
          </Content>

          <Avatar name={label} />
        </>
      ) : null}
    </Profile>
  );
};

export { MenuProfile };
